<template>
  <div class="read-only user-read-only">
    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        User
      </label>
      <router-link :to="`/users/${analyst.user_id}`">
        {{ analyst.name }}
      </router-link>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Job title
      </label>
      <span>
        {{ analyst.job_title || "---" }}
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Long Bio
      </label>
      <span v-html="analyst.long_bio || '---'" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    analyst: {
      type: Object,
      required: true,
    },
  },
}
</script>

